// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Components
import FormattedNote from './HelpComponents/FormattedNote';
import NoteTextArea from './HelpComponents/NoteTextArea';
// Helpers
import convertStringToHTML from '../../utils/convertStringToHTML';
// Styles
import * as styles from './NoteInput.scss';

export default class NoteInput extends Component {
  state = {
    inputIsActive: false,
    htmlContent: null,
    content: null,
    ...convertStringToHTML(this.props.value)
  };

  componentWillReceiveProps({ value }) {
    if (!this.props.value && value) {
      this.setState({ ...convertStringToHTML(value) });
    }
  }

  handleClick = () => this.setState({ inputIsActive: true });

  handleBlur = (evt) => {
    const { value } = evt.target;
    this.props.addNote(value);
    const updatedData = convertStringToHTML(value);

    this.setState({
      ...updatedData,
      inputIsActive: false
    });
  };

  renderContent = () => (
    <FormattedNote content={this.state.htmlContent || this.props.placeholder} />
  );

  renderTextArea = () => (
    <NoteTextArea
      handleBlur={this.handleBlur}
      content={this.state.content}
    />
  );

  render() {
    return (
      <div
        className={cx(styles.noteWrapper, this.props.className)}
        onClick={this.handleClick}
        style={{ color: (this.state.htmlContent || this.state.inputIsActive) ? '#000000' : '#979797' }}
      >
        {
          (this.state.inputIsActive) ? this.renderTextArea() : this.renderContent()
        }
      </div>
    );
  }
}

NoteInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  addNote: PropTypes.func
};
